import { PositionWrite } from 'src/app/shared/models/team/positionWrite';
import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';
import { TeamWrite } from './teamWrite';

export class TeamClone extends TeamWrite {
  public copyPeople: boolean = false;

  constructor(
    id: string,
    name: string,
    publicName: string,
    copyPeople: boolean,
    positions: PositionWrite[],
    attributes: AttributeWrite[],
    startDate?: Date,
    endDate?: Date
  ) {
    super(id, name, publicName, positions, attributes, startDate, endDate);
    this.copyPeople = copyPeople;
  }

  public static fromTeamWrite(teamWrite: TeamWrite, copyPeople: boolean): TeamClone {
    return new TeamClone(
      teamWrite.id,
      teamWrite.name,
      teamWrite.publicName,
      copyPeople,
      teamWrite.positions,
      teamWrite.attributes,
      teamWrite.startDate,
      teamWrite.endDate
    );
  }
}
